// src/components/EventSelector.jsx
import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import { obtenerPerfilActual, obtenerEventosAccesibles, filtrarEventosPorPermiso, obtenerArteEvento } from "../utils/eventAccess";

const CONFIG = {
  generarInvitaciones: { titulo: "Generar invitaciones", subtitulo: "Selecciona el evento para generar invitaciones.", permiso: "invitaciones", tipoArte: "invitaciones", destino: (id) => `/invitaciones/generar/${id}` },
  administrarInvitaciones: { titulo: "Administrar invitaciones", subtitulo: "Selecciona el evento para administrar sus invitaciones.", permiso: "reportes", tipoArte: "invitaciones", destino: (id) => `/admin/invitaciones/${id}` },
  generarEntradas: { titulo: "Comprar entradas", subtitulo: "Selecciona el evento para comprar entradas.", permiso: "entradas", tipoArte: "entradas", destino: (id) => `/entradas/generar/${id}` },
  administrarEntradas: { titulo: "Administrar entradas", subtitulo: "Selecciona el evento para administrar sus entradas.", permiso: "reportes", tipoArte: "entradas", destino: (id) => `/entradas/admin/${id}` },
  reservas: { titulo: "Reservas", subtitulo: "Selecciona el evento para administrar reservas.", permiso: "reservas", tipoArte: "general", destino: (id) => `/dashboard/reservas/evento/${id}` },
};

export default function EventSelector({ modo = "generarInvitaciones" }) {
  const navigate = useNavigate();
  const { profile } = useAuth();
  const config = CONFIG[modo] || CONFIG.generarInvitaciones;
  const [eventos, setEventos] = useState([]);
  const [cargando, setCargando] = useState(true);

  useEffect(() => {
    let alive = true;
    const cargarEventos = async () => {
      setCargando(true);
      try {
        const acceso = await obtenerPerfilActual();
        const { user, perfil, rol, eventosPermitidos } = acceso;
        if (!user) { navigate("/"); return; }

        const todos = await obtenerEventosAccesibles(config.permiso, acceso);
        const filtrados = filtrarEventosPorPermiso(todos, rol, eventosPermitidos, config.permiso, perfil, config.tipoArte);
        if (alive) setEventos(filtrados);
      } catch (error) {
        console.error("Error cargando eventos:", error);
        if (alive) { setEventos([]); alert(error.message || "No se pudieron cargar los eventos."); }
      } finally {
        if (alive) setCargando(false);
      }
    };
    cargarEventos();
    return () => { alive = false; };
  }, [navigate, config.permiso, config.tipoArte, profile]);

  return (
    <div className="pm-event-selector" style={page}>
      <div style={header}>
        <h2 style={{ margin: 0 }}>{config.titulo}</h2>
        <p style={subtitle}>{config.subtitulo}</p>
      </div>

      {cargando ? <p style={centerText}>Cargando eventos...</p> : eventos.length === 0 ? (
        <div style={emptyBox}>No tienes eventos asignados para este módulo.</div>
      ) : (
        <div style={grid}>
          {eventos.map((ev) => {
            const arte = obtenerArteEvento(ev, config.tipoArte);
            return (
              <button key={ev.id} type="button" style={card} onClick={() => navigate(config.destino(ev.id))}>
                <div style={imageBox}>{arte ? <img src={arte} alt={ev.nombre || "Evento"} style={img} onError={(e) => { e.currentTarget.style.opacity = 0.2; }} /> : <span style={{ color: "var(--pm-muted)" }}>Sin arte</span>}</div>
                <div style={title}>{ev.nombre || ev.titulo || "Evento"}</div>
                <div style={date}>{ev.fechaTexto || ev.fechaTexto || ev.dia || ""}</div>
              </button>
            );
          })}
        </div>
      )}
    </div>
  );
}

const page = { minHeight: "100vh", background: "var(--pm-bg)", padding: "40px 16px", boxSizing: "border-box" };
const header = { maxWidth: 960, margin: "0 auto 24px", textAlign: "center" };
const subtitle = { margin: "8px 0 0", color: "var(--pm-muted)" };
const centerText = { textAlign: "center", color: "var(--pm-muted)" };
const grid = { maxWidth: 1000, margin: "0 auto", display: "grid", gridTemplateColumns: "repeat(auto-fill, minmax(230px, 1fr))", gap: 20 };
const card = { background: "var(--pm-surface)", border: "1px solid var(--pm-border)", borderRadius: 14, overflow: "hidden", cursor: "pointer", textAlign: "left", boxShadow: "0 4px 10px rgba(0,0,0,0.06)" };
const imageBox = { height: 145, background: "var(--pm-border)", display: "flex", alignItems: "center", justifyContent: "center" };
const img = { width: "100%", height: "100%", objectFit: "cover" };
const title = { padding: "10px 12px 4px", fontWeight: 700, color: "var(--pm-text)" };
const date = { padding: "0 12px 12px", color: "var(--pm-muted)", fontSize: 13 };
const emptyBox = { maxWidth: 720, margin: "0 auto", padding: 24, background: "var(--pm-danger-bg)", border: "1px solid var(--pm-danger-text)", borderRadius: 12, color: "var(--pm-danger-text)", textAlign: "center" };
